import priceFilterComponentHtml from './pricefilter.component.html';
import './pricefilter.component.scss';

class PriceFilterController {
    constructor($scope, $document, $timeout, FullPageLoaderService, SubmitOnChangeService) {
        'ngInject';

        this.$scope = $scope;
        this.$document = $document;
        this.$timeout = $timeout;
        this.fullPageLoaderService = FullPageLoaderService;
        this.SubmitOnChangeService = SubmitOnChangeService;
        this.delayedSubmit = null;
        this.dragging = false;

        this.rangeCss = {
            left: '0%',
            width: '100%'
        };

        this.handleMinCss = {
            left: '0%',
            zIndex: '2'
        };

        this.handleMaxCss = {
            right: '100%',
            zIndex: '2'
        };

        this.startCurrentValues = {
            min: this.currentFrom,
            max: this.currentTo
        };
    }

    $onInit() {
        this.form = document.getElementById(this.formId);
        this.startCurrentValues = {
            min: this.currentFrom,
            max: this.currentTo
        };
        this.recalculate();

        if (this.currentFrom != this.minValue || this.currentTo != this.maxValue) {
            this.SubmitOnChangeService.forms.push({
                form: this.form,
                name: `${this.currentFrom}zł - ${this.currentTo}zł`,
                callback: () => {
                    this.currentFrom = '-';
                    this.currentTo = '-';
                    this.instantSubmit();
                }
            });
        }
    }

    $onChanges(changesObj) {
        this.form = document.getElementById(this.formId);
        this.startCurrentValues = {
            min: this.currentFrom,
            max: this.currentTo
        };
        this.recalculate();
    }

    $onDestroy() {
        if (this.delayedSubmit) {
            clearTimeout(this.delayedSubmit);
            this.delayedSubmit = null;
        }
    }

    mouseDownMin($event) {
        this.dragging = true;
        const dragingStartPosition = $event.pageX;
        const startDragingFrom = this.currentFrom;

        if (this.delayedSubmit) {
            this.$timeout.cancel(this.delayedSubmit);
            this.delayedSubmit = null;
        }

        const onMouseMove = ($event) => {
            if (!this.dragging) return;

            const moveDelta = $event.pageX - dragingStartPosition;
            const offsetPercentage = moveDelta / this.$scope.elementWidth;
            const valueChange = Math.round(offsetPercentage * (this.maxValue - this.minValue));
            let newMinValue = startDragingFrom + valueChange;

            if (newMinValue < this.minValue) {
                newMinValue = this.minValue;
            }

            if (newMinValue > this.currentTo) {
                newMinValue = this.currentTo
            }

            if (this.currentFrom == newMinValue) return;

            this.currentFrom = newMinValue;
            this.recalculate();
            this.$scope.$apply();
        };

        this.$document.on('mousemove', onMouseMove);

        this.$document.one('mouseup', () => {
            this.dragging = false;
            this.$document.off('mousemove', onMouseMove);
            this.submit();
        });
    }

    mouseDownMax($event) {
        this.dragging = true;
        const dragingStartPosition = $event.pageX;
        const startDragingTo = this.currentTo;

        if (this.delayedSubmit) {
            this.$timeout.cancel(this.delayedSubmit);
            this.delayedSubmit = null;
        }

        const onMouseMove = ($event) => {
            if (!this.dragging) return;

            const moveDelta = $event.pageX - dragingStartPosition;
            const offsetPercentage = moveDelta / this.$scope.elementWidth;
            const valueChange = Math.round(offsetPercentage * (this.maxValue - this.minValue));
            let newMaxValue = startDragingTo + valueChange;

            if (newMaxValue > this.maxValue) {
                newMaxValue = this.maxValue;
            }

            if (newMaxValue < this.currentFrom) {
                newMaxValue = this.currentFrom;
            }

            if (this.currentTo == newMaxValue) return;

            this.currentTo = newMaxValue;
            this.recalculate();
            this.$scope.$apply();
        };

        this.$document.on('mousemove', onMouseMove);

        this.$document.one('mouseup', () => {
            this.dragging = false;
            this.$document.off('mousemove', onMouseMove);
            this.submit();
        });
    }

    recalculate() {
        if (!this.maxValue || !this.minValue || this.maxValue == this.minValue) return;

        const leftOffset = Math.round(((this.currentFrom - this.minValue) / (this.maxValue - this.minValue)) * 100);
        const rightOffset = Math.round(((this.maxValue - this.currentTo) / (this.maxValue - this.minValue)) * 100);

        this.handleMinCss.left = this.rangeCss.left = leftOffset  + '%';
        this.handleMinCss.zIndex = '2';

        this.handleMaxCss.left = (100 - rightOffset)  + '%';
        this.handleMaxCss.zIndex = '2';

        this.rangeCss.width = (100 - leftOffset - rightOffset) + '%';

        if (this.currentFrom != this.currentTo) return;

        if (leftOffset >= rightOffset) {
            this.handleMinCss.zIndex = '3';
        } else {
            this.handleMaxCss.zIndex = '3';
        }
    }

    submit() {
        if (!this.form) return;

        if (this.delayedSubmit) {
            this.$timeout.cancel(this.delayedSubmit);
            this.delayedSubmit = null;
        }

        if (this.currentFrom == this.startCurrentValues.min &&
            this.currentTo == this.startCurrentValues.max) return;

        this.delayedSubmit = this.$timeout(() => {
            this.fullPageLoaderService.show = true;
            this.form.submit();
        }, 1000);
    }

    instantSubmit() {
        if (!this.form) return;

        if (this.delayedSubmit) {
            this.$timeout.cancel(this.delayedSubmit);
            this.delayedSubmit = null;
        }

        this.$timeout(() => {
            this.fullPageLoaderService.show = true;
            this.form.submit();
        }, 1);
    }

    changeMin(minValue) {
        if (minValue < this.minValue) {
            this.currentFrom = this.minValue;
        }

        if (minValue > this.currentTo) {
            this.currentFrom = this.currentTo;
        }

        this.recalculate();
        this.submit();
    }

    changeMax(maxValue) {
        if (maxValue > this.maxValue) {
            this.currentTo = this.maxValue;
        }

        if (maxValue < this.currentFrom) {
            this.currentTo = this.currentFrom;
        }

        this.recalculate();
        this.submit();
    }
}

let priceFilterComponent = {
    bindings: {
        formId: '@',
        minValue: '<',
        maxValue: '<',
        currentFrom: '<',
        currentTo: '<',
    },
    template: priceFilterComponentHtml,
    controller: PriceFilterController
}

export default priceFilterComponent;